require('../../../corporate-template/js/feature/iframe.js');